(function () {
  const element = document.getElementById("IphoneMenuConfig");
  if (!element || window.plugIphoneNavigation) return;
  window.plugIphoneNavigation = true;
  const config = JSON.parse(element.textContent);
  const host = document.querySelector("iphone-menu-experiment");
  if (!host) return;
  const panel = host.closest("details");
  const drawer = host.closest("header-drawer");
  const root = drawer.querySelector("details");
  const mobile = window.matchMedia("(max-width: 749px)");
  const template = host.querySelector("template");
  const control = host.querySelector(":scope > ul");
  const key = "plug_iphone_nav_v1_" + (config.enabled ? config.testId : "baseline");
  const firstKey = key + "_first";
  let experience = config.enabled ? "unassigned" : "baseline";
  let rendered = "control";
  let frozen = false;
  let assigned = false;
  let resolutionFinished = false;
  let resolving = false;
  let pageMeasured = false;
  let session = null;

  function consent() {
    try {
      return (
        !config.preview &&
        !config.rollout &&
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true
      );
    } catch {
      return false;
    }
  }

  function storage(type, action, name, value) {
    try {
      return window[type][action](name, value);
    } catch {
      return null;
    }
  }

  function save() {
    if (session && consent()) storage("sessionStorage", "setItem", key, JSON.stringify(session));
  }

  function loadSession() {
    if (!consent()) return null;
    try {
      session = JSON.parse(storage("sessionStorage", "getItem", key));
    } catch {
      session = null;
    }
    if (!session || Date.now() - session.lastSeen > 30 * 60 * 1000) {
      session = { lastSeen: Date.now(), collectionSeen: false, panelSeen: false, arrival: false };
    }
    session.lastSeen = Date.now();
    save();
    return session;
  }

  function capture(event, values = {}) {
    if (!consent() || !mobile.matches) return;
    const payload = {
      event,
      iphone_nav_release: "iphone-menu-v1",
      iphone_nav_test: config.enabled ? config.testId : "baseline",
      iphone_nav_experience: experience,
      iphone_nav_rendered: rendered,
      collection_handle: config.collection,
      ...values,
    };
    // Analytics failures must never interrupt navigation or the other sink.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch {}
    try {
      window.posthog?.capture?.(event, payload);
    } catch {}
  }

  function cohort() {
    try {
      const test = window.shoplift
        ?.getVisitorData?.()
        ?.visitorTests?.find((item) => item.testId === config.testId);
      if (!test?.hypothesisId) return null;
      return test.hypothesisId === config.hypothesisId ? "variant" : "control";
    } catch {
      return null;
    }
  }

  function apply() {
    if (panel.open || frozen || !mobile.matches || rendered === "variant") return;
    if (experience !== "variant") return;
    control.remove();
    host.appendChild(template.content.cloneNode(true));
    host.querySelector("[data-iphone-older]").replaceChildren();
    rendered = "variant";
    host.dataset.experience = rendered;
  }

  function measurePage() {
    if (!consent() || !mobile.matches || pageMeasured || !resolutionFinished) return;
    pageMeasured = true;
    loadSession();
    capture("iphone_nav_page_view");
    if (!session.assigned && (assigned || experience === "baseline")) {
      session.assigned = true;
      capture("iphone_nav_session");
    }
    if (config.collection === "apple-iphones" && !session.collectionSeen) {
      session.collectionSeen = true;
      capture("iphone_nav_collection_session");
    }
    if (config.isIphone) {
      capture("iphone_nav_product_view", { product_id: String(config.productId) });
      if (session.route && !session.arrival && Date.now() <= session.deadline) {
        session.arrival = true;
        capture("iphone_nav_pdp_reached", {
          product_id: String(config.productId),
          destination: session.route,
          primary_eligible: session.primaryEligible === true,
          opened_experience: session.openedExperience,
          opened_rendered: session.openedRendered,
          seconds_since_open: Math.round((Date.now() - session.openedAt) / 1000),
        });
      }
    }
    save();
    try {
      if (assigned) window.clarity?.("set", "iphone_nav_test_" + config.testId, experience);
    } catch {}
  }

  async function resolve() {
    if (resolving || resolutionFinished) {
      measurePage();
      return;
    }
    // Direct release is functional navigation, independent of consent or test assignment.
    if (config.rollout) {
      experience = "variant";
      resolutionFinished = true;
      apply();
      return;
    }
    if (config.preview) {
      experience = config.previewExperience === "variant" ? "variant" : "control";
      resolutionFinished = true;
      apply();
      return;
    }
    if (!config.enabled) {
      resolutionFinished = true;
      measurePage();
      return;
    }
    if (!config.testId || !config.hypothesisId || !consent() || !mobile.matches) return;
    resolving = true;
    const deadline = Date.now() + 10000;
    while (Date.now() < deadline && !resolutionFinished) {
      if (window.shoplift?.isHypothesisActive && cohort()) {
        try {
          const active = await Promise.race([
            window.shoplift.isHypothesisActive(config.hypothesisId),
            new Promise((_, reject) =>
              setTimeout(() => reject(new Error("assignment timeout")), 1000)
            ),
          ]);
          if (!consent()) {
            resolving = false;
            return;
          }
          const value = cohort();
          if (!value || active !== (value === "variant")) break;
          experience = value;
          assigned = true;
          resolving = false;
          resolutionFinished = true;
          apply();
          measurePage();
          if (frozen && rendered !== experience)
            capture("iphone_nav_delivery_failure", { reason: "panel_opened_before_assignment" });
          return;
        } catch {
          break;
        }
      }
      await new Promise((done) => setTimeout(done, 100));
    }
    resolving = false;
    resolutionFinished = true;
    capture("iphone_nav_delivery_failure", { reason: "assignment_unavailable" });
    measurePage();
  }

  function firstOpen() {
    if (!mobile.matches) return;
    frozen = true;
    if (!consent()) return;
    loadSession();
    if (!session.panelSeen) {
      session.panelSeen = true;
      session.openedAt = Date.now();
      session.deadline = session.openedAt + 10 * 60 * 1000;
      session.openedExperience = experience;
      session.openedRendered = rendered;
      const seen = storage("localStorage", "getItem", firstKey);
      storage("localStorage", "setItem", firstKey, "1");
      const storageWorks = storage("localStorage", "getItem", firstKey) === "1";
      session.primaryEligible =
        seen !== "1" && storageWorks && (assigned || experience === "baseline");
      capture("iphone_nav_first_panel_open", {
        primary_eligible: session.primaryEligible,
        storage_available: storageWorks,
      });
    }
    capture("iphone_nav_panel_open");
    save();
  }

  panel.querySelector(":scope > summary").addEventListener(
    "click",
    () => {
      if (!panel.open) firstOpen();
    },
    true
  );
  root.addEventListener("toggle", () => {
    if (root.open) capture("iphone_nav_drawer_open");
  });

  host.addEventListener("click", (event) => {
    const button = event.target.closest("[data-iphone-more]");
    if (!button) return;
    const list = host.querySelector("[data-iphone-older]");
    const expanded = button.getAttribute("aria-expanded") === "true";
    if (expanded && list.contains(document.activeElement)) button.focus();
    if (expanded) list.replaceChildren();
    else
      list.replaceChildren(
        ...template.content.querySelector("[data-iphone-older]").cloneNode(true).childNodes
      );
    list.hidden = expanded;
    button.setAttribute("aria-expanded", String(!expanded));
    button.querySelector("span").textContent = expanded ? "+" : "−";
    if (typeof trapFocus === "function")
      trapFocus(panel.querySelector("summary").nextElementSibling, button);
    capture("iphone_nav_more_models", { expanded: !expanded });
  });

  document.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest?.("a[href]");
      if (!link || !consent()) return;
      let url;
      try {
        url = new URL(link.href, location.href);
      } catch {
        return;
      }
      loadSession();
      if (host.contains(link)) {
        const destination = link.dataset.iphoneDestination || url.pathname.split("/").pop();
        capture("iphone_nav_link_clicked", { destination });
        if (session.openedAt && !session.arrival) session.route = destination;
      } else if (link.closest(".menu-drawer__grid")) {
        capture("iphone_nav_trending_clicked", { destination: url.pathname.split("/").pop() });
        session.route = null;
      } else if (
        url.origin !== location.origin ||
        !/\/(collections\/(apple-iphones|iphone-|boost-mobile-x-plug)|pages\/iphone-comparison-tool|products\/iphone-)/.test(
          url.pathname
        )
      ) {
        session.route = null;
      }
      save();
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      if (event.target.querySelector('[name="q"]')) {
        capture("iphone_nav_search_used");
        if (session) {
          session.route = null;
          save();
        }
      }
    },
    true
  );

  document.addEventListener("visitorConsentCollected", () => {
    if (consent()) {
      resolve();
      measurePage();
    } else {
      storage("sessionStorage", "removeItem", key);
      storage("localStorage", "removeItem", firstKey);
      session = null;
    }
  });

  mobile.addEventListener("change", () => {
    if (!mobile.matches && !panel.open && rendered === "variant") {
      host.querySelector("[data-iphone-variant]")?.remove();
      host.appendChild(control);
      rendered = "control";
    }
    if (mobile.matches) apply();
  });
  resolve();
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      pageMeasured = false;
      measurePage();
    }
  });
})();
